import * as React from "react";

import StandardCustomPropControl from "@v1/components/editor/page/element-editor/components/config-menus/StandardCustomPropControl";
import { useCustomPropDefinitionsWithValues } from "@v1/components/editor/page/element-editor/components/config-menus/utils";
import { selectDraftComponent } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";

import { StandardAccessibilityConfigMenu } from "./StandardAccessibilityConfigMenu";

const ACCESSIBILITY_CUSTOM_PROP_IDS = [
  "_accessibilityRole",
  "_accessibilityHidden",
  "_accessibilityChecked",
  "_accessibilityLabelledBy",
  "_accessibilityLabel",
  "_accessibilityHtmlTagType",
];

export const ContainerConfigMenu: React.FC = () => {
  const customProps = useCustomPropDefinitionsWithValues();
  const draftComponent = useEditorSelector(selectDraftComponent);
  if (!draftComponent) {
    return null;
  }

  return (
    <div className="relative flex flex-col gap-4">
      {customProps.map((customProp) => {
        return (
          !ACCESSIBILITY_CUSTOM_PROP_IDS.includes(customProp.definition.id) && (
            <div
              key={customProp.definition.id}
              className="border-border border-b pb-3 last:border-b-0 last:pb-0"
            >
              <StandardCustomPropControl
                draftComponent={draftComponent}
                customProp={customProp}
              />
            </div>
          )
        );
      })}
    </div>
  );
};

export const ContainerAccessibilityMenu: React.FC = () => {
  return (
    <StandardAccessibilityConfigMenu
      accessibilityPropIds={ACCESSIBILITY_CUSTOM_PROP_IDS}
    />
  );
};
